/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {
  Modal,
  PrimaryButton,
  DropdownIndicator,
  customStyles,
} from '../../../../components';
import {accountsCases, widgetCheck} from '../../../../assets/images/images';

const STATUSES = [
  {value: 'block', label: 'Block'},
  {value: 'allow', label: 'Allow'},
];

export default function ReviewProcessWithAIModal({
  open,
  setOpen,
  setData,
  data,
  onClick,
  loading,
}) {
  const [selectedStatus, setSelectedStatus] = useState(STATUSES[0]);

  useEffect(
    () => setData({...data, action: selectedStatus?.value}),
    [selectedStatus.value],
  );

  return (
    <Modal
      modalBg="bg-white80"
      show={open}
      onClose={setOpen}
      extraModalClasses="max-w-[480px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Review with AI"
    >
      <div className="m-6 text-start ">
        <label htmlFor="status" className="mt-6 mb-2 relative">
          Status
        </label>
        <Select
          defaultValue={selectedStatus}
          onChange={status => {
            setSelectedStatus(status);
            setData({...data, action: status?.value});
          }}
          options={STATUSES}
          className="basic-multi-select"
          classNamePrefix="react-select"
          components={{DropdownIndicator}}
          styles={customStyles}
          menuPlacement="auto"
        />
        <div
          className={`my-3 p-4 border rounded-lg ${
            selectedStatus?.value === 'block'
              ? 'bg-statusBg-404 border-status-404 text-status-404'
              : 'bg-statusBg-200 border-status-200 text-status-200'
          }`}
        >
          <div className="flex justify-between items-center">
            <div>
              <p className="font-bold text-sm mb-2">AI Suggestion</p>
              <p className="text-sm capitalize">{selectedStatus?.value}</p>
            </div>

            <div className="ml-6">
              <img
                src={
                  selectedStatus?.value === 'block'
                    ? accountsCases
                    : widgetCheck
                }
                alt=""
                width={selectedStatus?.value === 'allow' && 24}
              />
            </div>
          </div>
        </div>

        <div>
          <p className="font-bold text-sm mb-2">Reasons</p>
          <p className=" text-body text-sm mb-2 leading-6"></p>

          <ul className={'list-disc list-outside space-y-2 pl-6'}>
            <li className="text-body text-sm leading-6">
              <b>Unusually Large Amount:</b> The transaction amount of
              <strong> 100,000,000</strong> XAF is exceptionally high for this
              user. It is 10 times their previous maximum transaction
              (max_transaction_amount: 10,000,000) and over 111 times their
              average transaction amount (avg_transaction_amount: ~893,077). The
              system correctly flagged this with is_amount_unusual: true.
            </li>
            <li className="text-body text-sm leading-6">
              <b>New Beneficiary:</b> The user is sending this very large sum to
              a new beneficiary (is_new_beneficiary: true) for the first time.
              Large payments to unknown recipients are a common indicator of
              fraud or unauthorized activity.
            </li>

            <li className="text-body text-sm leading-6">
              <b>Complex International Transfer:</b> This is a cross-border
              transaction (is_cross_border: true) with several geographical
              inconsistencies. The transaction is initiated from Morocco, the
              sender&#39;s account country is Nigeria (NG), and the receiver is
              in England. This multi-country path is highly irregular and
              suspicious.
            </li>

            <li className="text-body text-sm leading-6">
              <b>Generic Receiver Name:</b> The receiver&#39;s name is listed as
              &#34;John Doe,&#34; which is a common placeholder name and raises
              suspicion about the legitimacy of the recipient&#39;s identity.{' '}
            </li>
          </ul>
        </div>
      </div>

      <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] border-transparent border-t-[#EFEFEF]">
        <PrimaryButton
          onClick={onClick}
          buttonText={'Use AI Suggestion'}
          className="w-full !h-10"
          disabled={
            selectedStatus?.value === 'block' && data?.reason?.length === 0
          }
          loading={loading}
        />
      </div>
    </Modal>
  );
}
